import { render } from "./StafetDonationStepPrivat.vue?vue&type=template&id=3844b3f0"
import script from "./StafetDonationStepPrivat.vue?vue&type=script&lang=js"
export * from "./StafetDonationStepPrivat.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__